import React from 'react';
import './StatusBadge.scss';

const StatusBadge = (props) => {

    return(
        <div className='status-wrapper'>
            <div className={props.variant}>
                {props.Status}
            </div>
            {
                typeof props.Reason !== 'undefined' &&
                <div className='reason-tooltip'>
                    사유 : {props.Reason}
                </div>
            }
        </div>
    )
}

export default StatusBadge;